import * as React from 'react';
import { SVGProps } from 'react';

const IconChatFilledSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M3 22c-.3 0-.5-.1-.7-.3-.3-.3-.4-.7-.2-1l1.8-5.3c-.6-1.2-.9-2.6-.9-3.9C3 7.9 5 4.6 8.3 3c1.3-.7 2.8-1 4.2-1h.5c4.9.3 8.7 4.1 9 8.9v.6c0 1.5-.3 2.9-1 4.3-1.6 3.2-4.9 5.2-8.5 5.2-1.3 0-2.6-.3-3.8-.8L3.4 22H3Z" />
  </svg>
);
export default IconChatFilledSizeM;
